module.exports = __webpack_public_path__ + "img/1795519195972894722.488423b7.png";